import type { IconName } from '@raiadrogasil/pulso-icons'
import type { ViewProps } from 'react-native'
import { type TTagProps, Tag } from '~/components/tag'
import * as S from './trade-tag.styles'

type TradeTagProps =
  | ({ type: 'blank'; children: string } & Omit<ViewProps, 'style'>)
  | ({
      type: 'default'
      variant: TTagProps['variant']
      children: string
      iconName: IconName
    } & Omit<ViewProps, 'style'>)

const TradeTag = (props: TradeTagProps) => {
  const { type, children, ...rest } = props
  if (!type) return null

  if (type === 'blank') {
    return (
      <S.TradeTagContainer {...rest}>
        <S.TradeTagTitle numberOfLines={1}>{children}</S.TradeTagTitle>
      </S.TradeTagContainer>
    )
  }
  return (
    <S.TradeDefaultContainer>
      <Tag.Root variant={props.variant}>
        <Tag.Icon symbol={props.iconName} />
        <Tag.Label>{children}</Tag.Label>
      </Tag.Root>
    </S.TradeDefaultContainer>
  )
}

export { TradeTag }
